import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaRegClock } from "react-icons/fa";
import Card from "../../shared/components/UIElements/Card";

const PracticeInfo = () => {
  return (
    <Card className="contact-info">
      <h3>Monument Dental</h3>
      <div className="contact-info__row">
        <FaMapMarkerAlt />
        <a href="https://goo.gl/maps/jh441hWp5yux3qVd9">
          236 Washington Street, Suite 1W
          <br />
          Monument, CO 80132
        </a>
      </div>
      <div className="contact-info__row">
        <FaPhoneAlt />
        <a href="tel:7194882721">719-488-2721</a>
      </div>
      <div className="contact-info__row">
        <FaEnvelope />
        <a href="mailto:monumentdental@hotmail.com">
          monumentdental@hotmail.com
        </a>
      </div>
      <div className="contact-info__row">
        <FaRegClock />
        <span>Monday–Thursday · 7:30am–5:00pm</span>
      </div>
    </Card>
  );
};

export default PracticeInfo;
